import React from 'react';

/**
 * InputField component
 *
 * This component displays a label and an input field for editing text.
 */
interface InputFieldProps {
  type?: string;
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  maxLength?: number;
  placeholder?: string;
  required?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  type,
  label,
  description,
  value,
  onChange,
  className,
  labelClassName,
  disabled,
  maxLength,
  placeholder,
  required,
}) => (
  <div className={`flex flex-col ${className ?? ''}`}>
    <label
      htmlFor={label.toLowerCase().replace(' ', '-')}
      className={`${labelClassName ?? 'text-base text-neutral-800 text-left'}`}
    >
      {label}
    </label>
    {description && (
      <p className="text-sm text-sm text-gray-500 text-left">{description}</p>
    )}
    <input
      disabled={disabled}
      type={type}
      id={label.toLowerCase().replace(' ', '-')}
      value={value}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      maxLength={maxLength}
      /* size=1 enables the input to shrink to the size of its content */
      size={1}
      className="py-2 pr-1.5 pl-3.5 bg-white text-neutral-800 rounded-lg border border-gray-300 opacity-70"
      placeholder={placeholder}
    />
  </div>
);

export default InputField;
